import { aiInit, aiCreateUserAction, aiProcessUserActionCache, aiProcessConversion, aiProcessUserActionAnalytics } from "./js/logic";
//import { Logger } from "./js/logger";


aiInit();

let aiPageView = false;
if(aiPageView == false)
{
  aiCreateUserAction({"type":"load"}, false, 0);
  aiPageView = true;
}

document.addEventListener('click', function(event) {
  aiCreateUserAction(event, false, 0);
}, false);
    
document.addEventListener('submit', function(event) {
    aiCreateUserAction(event, false, 0);
}, false);

let aiscrollTimer = null;
document.addEventListener("scroll", function(event) {
    if(aiscrollTimer !== null) {
        clearTimeout(aiscrollTimer);        
    }
    aiscrollTimer = setTimeout(function() 
    {
        aiCreateUserAction(event, false, 0);
    }, 800);
}, false)

window.dataLayer = window.dataLayer || new Proxy([], { set: (obj, prop, value) => {  
    if (prop !== 'length') {
      const pushEvent = new CustomEvent('datalayerpush', {
      detail: value
      });
  
      window.dispatchEvent(pushEvent);
    }
    return Reflect.set(obj, prop, value);
  }
});

window.addEventListener('datalayerpush', event => {
    var eventValue = ''
    var uniqueId = ''
    try
    {
      eventValue = event.detail['event']
      uniqueId = event.detail['gtm.uniqueEventId']
    }catch(error){
      console.log(error);
    }
});

(function() {
  setInterval(function () {
    aiProcessConversion();
  }, 200);
})();

(function() {
    setInterval(function () {
      aiProcessUserActionCache();
    }, 1000);
})();


(function() {
  setInterval(function () {
    aiProcessUserActionAnalytics();
  }, 1000);
})();



